



































































































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import { upload } from '../../common/util/ossUploadService';
import ElImageViewer from '@/components/imageviewer.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import AddressSelect from '@/components/AddressSelect.vue';
// import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { formRules } from '@/common/util/validator';
import { enums } from '@/common/enums';
import { CspOrder, yun } from '@/http';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
export interface Pagination1 {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        ElImageViewer,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        AddressSelect,
        SearchPanel,
        DraggerImg,
    },
})
export default class dirverManager extends Vue {
    public stateType = enums.stateType;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public dialogVisible = false;
    public handleClose() {
        this.iDImgs = [];
        this.driverLicenseImgs = [];
        this.QualificationCertificateImgs = [];
        this.dialogVisible = false;
        this.showid = true;
        this.showid2 = true;
    }

    public searchValue: any = {
        code: '',
        phone: '',
        name: '',
        idCode: '',
        enabled: true,
        carrierId: '',
        carrierName: '',
        syncStatus:'',
        asc: true,
        orderBy: '',
        
    };

    public timeList = [];

    public colData = JSON.parse(localStorage.getItem('dirverManager'))
        ? JSON.parse(localStorage.getItem('dirverManager'))
        : [    
              { title: '编码', isShow: true, disabled: false },
              { title: '司机姓名', isShow: true, disabled: false },
              { title: '车队名称', isShow: true, disabled: false },
              { title: '身份证号', isShow: true, disabled: false },
              { title: '手机号', isShow: true, disabled: false },
              { title: '驾驶证号', isShow: true, disabled: false },
              { title: '驾驶证有效期', isShow: true, disabled: false },
              { title: '从业资格证', isShow: true, disabled: false },
              { title: '从业资格证有效期', isShow: true, disabled: false },
              { title: '状态', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
              { title: '同步状态', isShow: true, disabled: false },
              { title: '同步时间', isShow: true, disabled: false },
          ];

    public labelPosition: string = 'right';

    public $refs!: {
        pagination: HTMLFormElement;
        pagination1: HTMLFormElement;
        multipleTable: HTMLFormElement;
        formData: HTMLFormElement;
        address: HTMLFormElement;
        updateEnabledForm: HTMLFormElement
    };

    public searchFunc() {
        sessionStorage.setItem('dirverManager_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }

    public resetSearchValue() {
        this.searchValue = {
            code: '',
            phone: '',
            name: '',
            idCode: '',
            enabled: true,
            carrierId: '',
            carrierName: '',
            syncStatus:'',
            asc: true,
            orderBy: '',
        };
        this.timeList = [];
        this.searchFunc();
    }

    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public rePagin1 = false;
    public tabelData = [];
    public total = 20;
    public isActive: boolean = false;

    public tableData: any = [];

    public async loadData() {
        this.loading = true;
        try {
            let res = await yun.GetDriverList({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setNowPage(this.searchPagin.count);
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
        } catch {
            this.loading = false;
        }
    }

    public showid: any = true;
    public showid2: any = true;
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('dirverManager', JSON.stringify(this.colData));
    }
    public created() {
        if (this.$route.query.type == 'detail') {
            this.toEdit({ id: this.$route.query.id });
        }
    }
    public mounted() {
        if (sessionStorage.getItem('dirverManager_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('dirverManager_searchValue'));
            this.searchPagin = sessionStorage.getItem('dirverManager_page')
                ? JSON.parse(sessionStorage.getItem('dirverManager_page'))
                : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('dirverManager_page')
                ? JSON.parse(sessionStorage.getItem('dirverManager_page'))
                : this.searchPagin;

            this.loadData();
        }
    }

    public getMore() {
        this.expandType = !this.expandType;
    }


    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('dirverManager_page', JSON.stringify(pagin));
        this.loadData();
    }

    iDImgs: any = [];
    QualificationCertificateImgs: any = [];
    driverLicenseImgs: any = [];
    public formData: any = {
        id: '',
        phone: '',
        name: '',
        idCode: '',
        driverLicenseNo: '',
        enabled: true,
        iDImg: '',
        driverLicenseImg: '',
        QualificationCertificateImg: '',
    };
    public title = '新增司机';
 

    public async toEdit(datas) {
        this.title = '司机详情';
        this.iDImgs = [];
        this.driverLicenseImgs = [];
        this.QualificationCertificateImgs = [];
        this.formData = {
            phone: '',
            id: '',
            name: '',
            idCode: '',
            enabled: true,
            iDImg: '',
            driverLicenseImg: '',
            QualificationCertificateImg: '',
        };
        let res = await yun.DriverDetai1(datas.id);
        console.log('ress', res);
        if (res.idImg) {
            this.iDImgs.push({
                name: 'idImg',
                url: res.idImg,
            });
        }
        if (res.driverLicenseImg) {
            this.driverLicenseImgs.push({
                name: 'driverLicenseImgs',
                url: res.driverLicenseImg,
            });
        }
        if (res.qualificationCertificateImg) {
            this.QualificationCertificateImgs.push({
                name: 'QualificationCertificateImgs',
                url: res.qualificationCertificateImg,
            });
        }
        Object.keys(res).forEach((key) => {
            this.formData[key] = res[key];
        });
        this.formData.QualificationCertificateImg = res.qualificationCertificateImg;
        this.formData.driverLicenseImg = res.driverLicenseImg;
        this.formData.iDImg = res.idImg;

        // this.$refs.formData.resetFields();
        this.dialogVisible = true;
    }



    /** 新增 */
    public selectedId: any = '';
    public selectionRow = [] as any;

    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    urls;
    showViewer: any = false;
    dialogImageUrl = '';
    dialogImage: any = false;
    public handlePreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogImage = true;
    }
    public onClose() {
        this.dialogImage = false;
    }
    cc;
    store;
    async handleUpload1(param, data) {
        this.cc = data;
        console.log('123', param, data);
        let res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            var imageUrl = res.res.requestUrls[0].split('?')[0];
            this.$set(this.formData, data + '', imageUrl);
            console.log('12344', this.formData);
        } else {
            this.$alert(`上传失败，请重新上传`);
        }
    }
    handleRemove1(param, data) {
        console.log('datas', data, this.formData);
        this.$set(this.formData, data + '', '');
    }

    async updateImage(e: any) {
        let param = new FormData();
        const file = e.file;
        param.append('excel', file);
        let res = await yun.DriverImportCars(param);
        if (res) {
            this.$emit('updateSearch');
            this.$message.success('导入成功!');
        } else {
            this.$message.error('导入失败!');
        }
    }

    public selectDirver: any = {};
    public carid: any = '';
    selectCar(data) {
        console.log(data);
        this.carid = data.id;
    }
    selectCar1(data) {
        this.searchValue.carrierId = data.id;
    }


    public carName = '';
    async querySearch(queryString, cb) {
        let res = await yun.GetCarList({ carCode: this.carName });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.carCode,
                id: dd.id,
            };
            result.push(xx);
        });
        cb(result);
    }
    public carrierName = '';
    selectList = [];
    async querySearch1(queryString, cb) {
        this.searchValue.carrierId = '';
        let res = await yun.GetCarrierList({ Name: this.searchValue.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    public async exportExcel() {
        let res = await yun.DriverExport({ ...this.searchValue });
    }
    public exportExcel1() {}
    closeViewer() {
        this.showViewer = false;
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'name':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
            case 'idCode':
                {
                    this.searchValue.orderBy = 2;
                }
                break;
            case 'phone':
                {
                    this.searchValue.orderBy = 3;
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = 4;
                }
                break;
        }
        this.loadData();
    }
  
    public dialogConfig: boolean = false;
    public disableReasonDialog: boolean = false;
    confirmClose(){
        this.dialogConfig = false;
    }
    public updateEnabledForm = {
        phone:'',
        enabled:null,
        disableReason: ''
    }
    disableReasonConfirm(){
         let data = this.updateEnabledForm;
          if(data.enabled){
              this.$refs.updateEnabledForm.validate(async (valid) => {
               if(valid){
                   yun.Enable({phone:data.phone,enabled:!data.enabled,disableReason:data.disableReason}).then(res=>{
                  this.$message.success('禁用成功');
                    this.disableReasonDialog = false;
                    this.loadData()
                })  
               }
            })
          }else{
             yun.Enable({phone:data.phone,enabled:!data.enabled,disableReason:data.disableReason}).then(res=>{
                this.$message.success('启用成功');
                    this.dialogConfig = false;
                    this.loadData();
            }) 
          }
      

    }
    updateEnabled(data){
        this.updateEnabledForm = {
            phone:data.phone,
            enabled:data.enabled,
            disableReason: ''
        }
        if(data.enabled){
             this.disableReasonDialog = true;
              this.$refs.updateEnabledForm.resetFields();
        }else{
             this.dialogConfig = true;
        }
    }
    public dialogConfig2: any = {
        title: '',
        show: false,
    };
    confirmClose2() {
        this.dialogConfig2 = {
            title: '',
            show: false,
        };
    }
    public carId:string = '';
    public sync(id){
        this.carId = id;
        this.dialogConfig2 = {
            title: '同步该司机至山鹰TMS系统',
            show: true,
        };
    }
    async confirmOk() {
        yun.PushDriverToTms(this.carId).then(() => {
            this.$message.success('操作成功');
            this.loadData();
        });
        this.dialogConfig2 = {
            show: false,
        };
    }
}
